import { createLogic } from 'redux-logic';
import { APP_ON_RESIZE } from '../constants';
import { onUpdateBreakPoints } from '../actions/AppActions';

export const resizeLogic = createLogic({
  type: APP_ON_RESIZE,
  latest: true,
  processOptions: {
    dispatchReturn: true,
    successType: onUpdateBreakPoints
  },
  process() {
    return {
      tablet: window.innerWidth < 1024,
      mobile: window.innerWidth < 720,
      md: window.innerWidth < 500,
    };
  }
});

export default [
  resizeLogic
];
